import { BsClock, BsGlobe2, BsShieldCheck, BsTruck } from "react-icons/bs";

export default function FeatureHighlights() {
  const features = [
    { icon: <BsTruck />, title: "Fast Delivery", text: "Same-day available" },
    { icon: <BsShieldCheck />, title: "100% Insured", text: "Your parcels protected" },
    { icon: <BsGlobe2 />, title: "Eco-Friendly", text: "Sustainable delivery" },
    { icon: <BsClock />, title: "Real-Time Tracking", text: "Always know where it is" },
  ];

  return (
    <section aria-label="Why Parcelin" className="relative z-10 max-w-6xl mx-auto w-full px-4 sm:px-5 -mt-6 md:-mt-10">
      <ul className="grid grid-cols-2 lg:grid-cols-4 gap-px overflow-hidden rounded-3xl bg-purple-100 shadow-xl shadow-purple-900/10 ring-1 ring-purple-100">
        {features.map((feature) => (
          <li key={feature.title} className="flex items-center gap-3 bg-white px-4 py-5 sm:px-6">
            <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-purple-600 text-white text-xl" aria-hidden="true">
              {feature.icon}
            </span>
            <span className="min-w-0">
              <span className="block font-semibold text-gray-900">{feature.title}</span>
              <span className="block text-sm text-gray-600">{feature.text}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
